import React from "react";
import GlobalFonts from "./fonts/fonts";
import Header from "./components/Header";
// import Hero from "./components/Hero";
import Footer from "./components/Footer";
import PreFooter from "./components/PreFooter";
// import Tiles from "./components/Tiles";
// // import Activity from "./components/Activity";
// // import Terms from "./components/TermsConditions";
import { GlobalStyle } from "./styles";
import { Routes, Route, Switch } from "react-router-dom";
import Home from "./pages/home";
import Activity from "./pages/activity";
import Terms from "./pages/tcs";
import Swim from "./pages/swim";
import Kai from "./pages/kai";
import Book from "./pages/book";
import Hikoi from "./pages/hikoi";
import Song from "./pages/song";
import Picnic from "./pages/picnic";
import Birds from "./pages/birds";
import Sky from "./pages/sky";
import Arty from "./pages/arty";
import Outdoors from "./pages/outdoors";
import Backyard from "./pages/backyard";
import Barefoot from "./pages/barefoot";
import Friend from "./pages/friend";
import Visit from "./pages/visit";
import Whanau from "./pages/whanau";
import Dance from "./pages/dance";

import Protect from "react-app-protect";
import "react-app-protect/dist/index.css";

const App = () => {
  return (
    <div className="App">
      {/* <Protect sha512="b52f45e5c9b3d497abcece7d69226083331de2c936337d3e327e372f96555234002e1962e7c10735e788bae61b5da4dd2baa670875d924ad7ee48c6d05f27447"> */}
      <GlobalStyle />
      <GlobalFonts />

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/swim" element={<Swim />} />
        <Route path="/kai" element={<Kai />} />
        <Route path="/book" element={<Book />} />
        <Route path="/hikoi" element={<Hikoi />} />
        <Route path="/song" element={<Song />} />
        <Route path="/picnic" element={<Picnic />} />
        <Route path="/birds" element={<Birds />} />
        <Route path="/sky" element={<Sky />} />
        <Route path="/arty" element={<Arty />} />
        <Route path="/outdoors" element={<Outdoors />} />
        <Route path="/backyard" element={<Backyard />} />
        <Route path="/barefoot" element={<Barefoot />} />
        <Route path="/friend" element={<Friend />} />
        <Route path="/visit" element={<Visit />} />
        <Route path="/whanau" element={<Whanau />} />
        <Route path="/dance" element={<Dance />} />
        {/* <Route path="/404" element={<Lost />} /> */}
      </Routes>

      <PreFooter />
      <Footer />
      {/* </Protect> */}
    </div>
  );
};

export default App;
